import { render, staticRenderFns } from "./UpdateGate.vue?vue&type=template&id=566e5d5c&"
import script from "./UpdateGate.vue?vue&type=script&lang=js&"
export * from "./UpdateGate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports